<div class="explanation">✍️ Introduceți necesarul de tablă grupat după lungime<br />
  📏 Lungimea trebuie sa fie intre 0.50 si 7 metri<br />
  <div *ngIf="models?.roof">📏 Modelul selectat de tablă are o lățime utilă de {{models?.roof?.effectiveWidth}} metri și o lățime
    totală {{models?.roof?.totalWidth}} metri
  </div>
</div>
<form *ngFor="let tile of measurements.tilesByHeight; let i = index" [formGroup]="forms[i]" [name]="'one-slope-measurements'+i">
  <mat-form-field appearance="fill">
    <mat-label>Bucăți de tablă</mat-label>
    <input matInput autocomplete="off" type="text" pattern="^\d+$" formControlName="count"
           (change)="formIntegerInputChange($event,  i,'count')" required>
    <span matSuffix>buc.</span>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>La lungimea</mat-label>
    <input matInput type="text" autocomplete="off" pattern="^[0-9]+[,.]?[0-9]*$"
           (change)="formDecimalInputChange($event,  i,'height')"
           formControlName="height" required>
    <span matSuffix>m.</span>

  </mat-form-field>
<!--  <button mat-raised-button aria-label="Șterge" title="Șterge" color="warn" (click)="remove(i)" gaEvent="custom_measurements_delete_height"-->
<!--          gaCategory="buttons_tracking">-->
    <mat-icon color="warn" (click)="remove(i)">delete</mat-icon>
<!--  </button>-->
</form>
<div style="text-align: center;">
  <button mat-raised-button color="primary" (click)="addHeight()" gaEvent="custom_measurements_add_height" gaCategory="buttons_tracking">
    <mat-icon matPrefix>add</mat-icon>
    Adaugă o lungime
  </button>
</div>

<step-navigation [disabled]="!allFormsAreValid" (forwardClickEmitter)="updateState()" [nextButtonLabel]="nextButtonLabel"></step-navigation>
